import Popup from '../plugins/PluginPopup'
import SVGInject from '@iconfu/svg-inject'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import Swiper from 'swiper'
import {
    Navigation,
    EffectFade,
} from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade';

declare const ciapeq: { [key: string]: string };

window.addEventListener('load', () => {

    const hash = window.location.hash;

    let locNumber = '';
    if (hash.length > 0) {
        // If hash exists, remove # from hash and change to uppercase

        locNumber = hash.replace("#", "");
        console.log(ciapeq);
        console.log(locNumber);

        // get only part from hash to ? if there are any tracking attributes
        locNumber = locNumber.split("?")[0];
        console.log(locNumber);

        // Save default hash before editing
        const hashBackup = locNumber;

        locNumber = locNumber.toUpperCase();
        console.log(locNumber);


        // Check if array with all available dwellings contains id found in url
        // console.log({ locNumber, allApartments: ciapeq })
        if (ciapeq[locNumber]) {
            console.log(ciapeq[locNumber]);
            // If true, create url for dwelling
            const url = `/popup/?id=${ciapeq[locNumber]}`
            getPopupsLink(url)
        }

    }

})

function getPopupsLink(url: string): void {

    const template = document.querySelector<HTMLElement>(
        '[data-item="content-popup"]',
    )
    // const url = `data-url="/popup/?id=129"`
    console.log(url)
    new Popup({
        trigger: 'auto',
        openBtn: null,
        title: '',
        content: '',
        isTemplate: true,
        template: template,
        iconClose: false,
        btnClose: true,
        btnCloseContent: '',
        customClass: 'popup-rent',
        session: false,
        onAfterOpen() {
            handlePopupOpen(url)

        },
        onAfterClose() {
            history.replaceState(null, "", window.location.pathname + window.location.search);

        },
    })
}

function handlePopupOpen(url: string): void {
    const popup = document.querySelector<HTMLElement>('[data-popup="true"]')

    if (!popup) return

    const content = popup.querySelector<HTMLElement>('[data-popup="content"]')

    // initializePopupPickers()

    if (url && content) {
        fetchAndProcessContent(url, content, popup)
    }
}

function fetchAndProcessContent(
    url: string,
    content: HTMLElement,
    popup: HTMLElement,
): void {
    fetch(url, {
        method: 'get',
    })
        .then((res) => res.text())
        .then((data) => {
            // Add new content
            content.innerHTML = '';
            content.insertAdjacentHTML('afterbegin', data)

            // Inject SVGs
            const svg = content.querySelectorAll('[data-item="svg"]')
            SVGInject.setOptions({
                afterInject: null,
            })
            SVGInject(svg)

            // Setup custom scrollbar
            setupCustomScrollbar(popup)

            new Swiper(`[data-slider="gallery-popup-slider"]`, {
                modules: [Navigation, EffectFade],
                slidesPerView: 1,
                slidesPerGroup: 1,
                speed: 300,
                effect: 'fade',
                navigation: {
                    nextEl: '[data-controls="next"]',
                    prevEl: '[data-controls="prev"]',
                },
                on: {
                    init(swiper: any) {
                        const activeIndex = swiper.activeIndex;

                        const activeSlide = swiper.slides[activeIndex] as HTMLElement;

                        const name = activeSlide.dataset.name;

                        if (!name) return;

                        const titleEl = document.querySelector('[data-slider="gallery-popup-slider"] [data-slide-popup-title]') as HTMLElement | null;

                        if (titleEl) {
                            titleEl.textContent = name;
                        }
                    },
                    slideChangeTransitionEnd(swiper: any) {
                        const activeIndex = swiper.activeIndex;

                        const activeSlide = swiper.slides[activeIndex] as HTMLElement;

                        const name = activeSlide.dataset.name;

                        if (!name) return;

                        const titleEl = document.querySelector('[data-slider="gallery-popup-slider"] [data-slide-popup-title]') as HTMLElement | null;

                        if (titleEl) {
                            titleEl.textContent = name;
                        }
                    }
                }
            })


            document.querySelectorAll('[data-popup-history-price]').forEach((elem) => {

                // @ts-ignore
                tippy(elem, {
                    content(reference) {
                        const template = reference.getAttribute('data-content');
                        if (template) {
                            return template;
                        }
                    },
                    theme: 'price-history-plan',
                    placement: 'right-end',
                    arrow: false,
                    interactive: true,
                    allowHTML: true,
                    trigger: 'click',
                    appendTo: () => document.body,
                    maxWidth: 'none',
                });
            });

            document.querySelectorAll('[data-tooltip-clause-more-popup]').forEach((elem) => {

                // @ts-ignore
                tippy(elem, {
                    content(reference) {
                        const template = reference.getAttribute('data-content');
                        if (template) {
                            return template;
                        }
                    },
                    theme: 'clause-more',
                    placement: 'right-end',
                    arrow: false,
                    interactive: true,
                    allowHTML: true,
                    // trigger: 'click',
                    appendTo: () => document.body,
                    maxWidth: 'none',
                });
            });
        })
}

function setupCustomScrollbar(popup: HTMLElement): void {
    const scrollsContainer = popup.querySelector<HTMLElement>(
        '[data-popup="wrapper"]',
    )

    if (!scrollsContainer) return

    if (scrollsContainer.getAttribute('data-custom-scroll-active') !== 'true') {
        scrollsContainer.setAttribute('data-custom-scroll-active', 'true')
        new window.simplebar(scrollsContainer, {
            autoHide: false,
        })
    }
}